<template lang="pug">
div(style='padding-top: 20px')
    span.titulo {{ $t('mensagens.territorio.comercializacao.titulo') }}
    <br/>
    el-row.tabela(:gutter='24')
        el-col(:span='4')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.produto') }}
        el-col(:span='4')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.quantidade') }}
        el-col(:span='4')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.unidadeDeMedida') }}
        el-col(:span='3')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.safra') }}
        el-col(:span='4')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.numeroContrato') }}
        el-col(:span='4')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.fornecedor') }}
        el-col(:span='1')
            span.tituloColuna {{ $t('mensagens.territorio.comercializacao.operacoes') }}
        el-col(:span='24', style='padding: 0')
            div(v-for='(comercializacao, index) in comercializacoes')
                el-form(:model='comercializacao', :ref='"formCom" + index')
                    el-col(:span='4')
                        el-form-item.margin(prop='produto')
                            el-select(
                                v-model='comercializacao.produto.id',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                                el-option(
                                    v-for='prod in produtos',
                                    :key='prod.id',
                                    :label='prod.nome',
                                    :value='prod.id'
                                )
                    el-col(:span='4')
                        el-form-item.margin(prop='quantidade')
                            el-input-number(
                                v-model='comercializacao.quantidade',
                                :precision='2',
                                :step='0.01',
                                :min='0.0',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                    el-col(:span='4')
                        el-form-item.margin(prop='unidadeMedida')
                            el-select(
                                v-model='comercializacao.unidadeMedida.id',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                                el-option(
                                    v-for='uni in unidadesMedida',
                                    :key='uni.id',
                                    :label='uni.nome + " - " + uni.simbolo',
                                    :value='uni.id'
                                )
                    el-col(:span='3')
                        el-form-item.margin(prop='safra')
                            el-select(
                                v-model='comercializacao.safra.id',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                style='width: 100%',
                                @change='atualizar()'
                            )
                                el-option(
                                    v-for='safra in safras',
                                    :key='safra.id',
                                    :label='safra.safraAno',
                                    :value='safra.id'
                                )
                    el-col(:span='4')
                        el-form-item.margin(prop='numeroContrato')
                            el-input(
                                v-model='comercializacao.numeroContrato',
                                :placeholder='$t("mensagens.territorio.comercializacao.numeroContrato")',
                                maxlength='30',
                                show-word-limit
                            )
                    el-col(:span='4')
                        el-form-item.margin(prop='fornecedor')
                            el-input(
                                v-model='comercializacao.fornecedor',
                                :placeholder='$t("mensagens.territorio.comercializacao.fornecedor")',
                                maxlength='50',
                                show-word-limit
                            )
                    el-col(:span='1')
                        .block-comercializacao
                            i.el-icon-delete.icon(
                                :popup='$t("mensagens.comuns.remover")',
                                @click='openModalRemover(index)',
                                style='color: #900000'
                            )
                            i.el-icon-circle-plus-outline.icon(
                                :popup='$t("mensagens.comuns.adicionar")',
                                ,
                                @click='addCom()'
                            )
    #modal-delete-comercializacao-are-you-sure.row(
        v-if='deleteComercializacaoModal'
    )
        el-dialog(:visible.sync='deleteComercializacaoModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(
                    style='text-align: left; font-size: 18px'
                ) {{ $t('mensagens.territorio.comercializacao.removerComercializacao') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                h2.mb16 {{ $t('mensagens.territorio.comercializacao.temCertezaqueDesejaRemoverRegistro') }}
                .buttons-modal.mb16
                    el-button(size='mini', @click='closeModalRemover')
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteComercializacao'
                    )
                        | {{ $t('mensagens.comuns.remover') }}
</template>

<script>
import territorioService from '@/services/TerritorioService';
import UtilsService from '../../services/UtilsService';

export default {
    name: 'ComercializacaoTerritorio',

    props: {
        comercializacaoSelected: {
            type: Array,
            required: false
        }
    },

    data() {
        return {
            produtos: [],
            unidadesMedida: [],
            safras: [],
            comercializacoes: [
                {
                    produto: {
                        id: ''
                    },
                    quantidade: '',
                    unidadeMedida: {
                        id: ''
                    },
                    safra: {}
                }
            ],
            deleteComercializacaoModal: false,
            indexRemover: null
        };
    },

    mounted() {
        this.buscaProdutos();
        this.buscaUnidadesMedida();
        this.buscaSafras();

        if (
            this.comercializacaoSelected &&
            this.comercializacaoSelected.length > 0
        ) {
            this.comercializacoes = this.comercializacaoSelected;
        }
    },
    methods: {
        async buscaProdutos() {
            await territorioService.findProdutos().then(({ data }) => {
                this.produtos = data;
            });
        },

        async buscaUnidadesMedida() {
            await territorioService.findUnidadesMedida().then(({ data }) => {
                this.unidadesMedida = data;
            });
        },

        async buscaSafras() {
            this.safras = (await UtilsService.getSafras()).data;
        },

        openModalRemover(index) {
            this.indexRemover = index;
            this.deleteComercializacaoModal = true;
        },

        closeModalRemover() {
            this.deleteComercializacaoModal = false;
        },

        deleteComercializacao() {
            if (this.indexRemover != null) {
                this.comercializacoes.splice(this.indexRemover, 1);
                if (
                    this.indexRemover === 0 &&
                    this.comercializacoes.length === 0
                ) {
                    this.addCom();
                }
                this.indexRemover = null;
                this.deleteComercializacaoModal = false;
                this.atualizar();
            }
        },

        addCom() {
            this.comercializacoes.push({
                produto: {
                    id: ''
                },
                quantidade: '',
                unidadeMedida: {
                    id: ''
                },
                safra: {}
            });
            this.atualizar();
        },

        atualizar() {
            this.$bus.$emit('comercializacao', this.comercializacoes);
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-size: 14px;
    color: var(--primary);
    font-weight: bold;
}
.tituloColuna {
    font-size: 13px;
    color: #19194b;
}

.tabela {
    width: 100%;
    padding-top: 15px;
    padding-bottom: 10px;
}
.icon {
    font-size: 20px;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 8px;
    color: #19194b;
}
.margin {
    margin-bottom: 12px;
}

.mb16 {
    margin-bottom: 16px;
}
.buttons-modal {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}
#modal-delete-comercializacao-are-you-sure {
    text-align: center;
}
.block-comercializacao {
    display: flex;
}
</style>
